import type { ButtonHTMLAttributes, ReactText } from "react";
import * as palette from "../../palette";

type TMenuActionButtonIntent = "primary" | "danger" | "unspecified";

interface IMenuActionButtonItemProps extends ButtonHTMLAttributes<any> {
  intent?: TMenuActionButtonIntent;
  children: ReactText;
}

export default function MenuActionButtonItem({
  children,
  disabled,
  intent = "unspecified",
  ...props
}: IMenuActionButtonItemProps) {
  return (
    <li
      css={{
        marginRight: -8,
        marginLeft: -8,
      }}
    >
      <button
        type="button"
        disabled={disabled}
        css={{
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          width: "100%",
          margin: 0,
          padding: "0px 8px",
          overflow: "visible",
          fontSize: 14,
          lineHeight: 1.333,
          letterSpacing: 0.6,
          backgroundColor: "transparent",
          // border: "none",
          borderRadius: 4,
          cursor: "pointer",
          transition: "all 60ms ease 0s",
          userSelect: "none",
          pointerEvents: disabled ? "none" : "all",
          WebkitAppearance: "none",
          ...getIntentCSS(intent),
        }}
        {...props}
      >
        <span
          css={{
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          {children}
        </span>
      </button>
    </li>
  );
}

function getIntentCSS(intent: TMenuActionButtonIntent) {
  if (intent === "danger") {
    return {
      color: palette.mojo,
      border: "solid 1px transparent",
      "&:hover": {
        color: palette.stiletto,
        fontWeight: 500,
        backgroundColor: palette.vanillaIce,
      },
      "&:focus": {
        backgroundColor: palette.white,
        border: `solid 1px ${palette.mojo}`,
        outline: "none",
        boxShadow: `0 0 0 3px ${palette.vanillaIce}`,
      },
    };
  }

  if (intent === "primary") {
    return {
      color: palette.mineShaft,
      border: "solid 1px transparent",
      "&:hover": {
        color: palette.royalBlue,
        backgroundColor: palette.selago,
      },
      "&:focus": {
        backgroundColor: palette.white,
        border: `solid 1px ${palette.cornflowerBlue}`,
        outline: "none",
        boxShadow: `0 0 0 3px ${palette.tropicalBlue}`,
      },
    };
  }

  return {
    color: palette.mineShaft,
    border: "solid 1px transparent",
    "&:hover": {
      backgroundColor: palette.catskillWhite,
    },
    "&:focus": {
      backgroundColor: palette.white,
      border: `solid 1px ${palette.cornflowerBlue}`,
      outline: "none",
      boxShadow: `0 0 0 3px ${palette.tropicalBlue}`,
    },
  };
}
